import {Component, Inject} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';

import {ErrorResponse} from '../../../../data/model/errorResponse';
import {OrganisationsDataManager} from '../../../../data/organisations.datamanager';
import {UploadDataManager} from '../../../../data/upload.datamanager';

@Component({
  selector: 'import-users-dialog',
  templateUrl: './import-users-dialog.html'
})
export class ImportUsersDialogComponent {
  xlsx: File = null;

  constructor(
      private uploadDataManager: UploadDataManager,
      private organisationsDataManager: OrganisationsDataManager,
      public dialogRef: MatDialogRef<ImportUsersDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  handleFileInput(files: FileList) {
    this.xlsx = files.item(0);
  }

  onAddClick() {
      const filereader: FileReader = new FileReader();
      filereader.readAsDataURL(this.xlsx);
      filereader.onload = (e) => {
        const url = filereader.result;
        const base64Data =
            url.substr(url.indexOf('base64,') + 'base64,'.length);

        let organisationId = null;
        if(localStorage.getItem('role') !== 'superadmin'){
            organisationId = localStorage.getItem('organisation');
        } else {
            organisationId = this.data.selectedOrganisation._id
        }

        this.uploadDataManager
            .uploadUsersToApi(organisationId, base64Data)
            .subscribe(
                (response) => {
                  this.closeDialogSuccess('Users succesfully imported.');
                },
                (err) => {
                  this.closeDialogWithError(err.json());
                });
      };
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  openFileUpload() {
    document.getElementById('file-id').click();
  }

  closeDialogWithError(error: ErrorResponse) {
    this.dialogRef.close(error);
  }

  closeDialogSuccess(message: string) {
    this.dialogRef.close(message);
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/users/import/import.users.dialog.component.ts